import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { styled } from 'styled-components';

interface DroppableUngroupedGridProps {
  index: number;
  children: React.ReactNode;
}

const Container = styled.div<{ $isOver: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  min-height: 40px;
  border-radius: 8px;
  border: 2px solid transparent;
  padding: 10px;
  transition: background 0.15s, border-color 0.15s;
  ${(p) =>
    p.$isOver &&
    `
    background: #ebf8ff;
    border-color: #3182ce;
    border-style: dashed;
  `}
`;

const DroppableUngroupedGrid: React.FC<DroppableUngroupedGridProps> = ({ index, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id: `ungrouped::${index}` });

  return (
    <Container ref={setNodeRef} $isOver={isOver}>
      {children}
    </Container>
  );
};

export default DroppableUngroupedGrid;
